import React from 'react';
import { Link } from 'react-router-dom';
import { flowRight } from 'lodash/fp';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles } from '@material-ui/core/styles';

import Access from 'ui/Access';
import { MTable } from 'ui/mtable/MTable';
import EditButton from 'ui/EditButton';
import DetailsButton from 'ui/DetailsButton';
import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';
import WhiteBack from '../../../WhiteBack';
import { withAppContext } from '../../../AppContext';

import { removeGroups, loadGroups } from './services';

const styles = theme => ({
    button: {
        margin: theme.spacing(),
        fontSize: '10px',
    },
    leftIcon: {
        marginRight: theme.spacing(),
        fontSize: '15px',
    },
});

const DELETE_GROUPS = 'deleteGroups';

class Groups extends React.Component {
    state = {
        groups: [],
        groupsLoading: true,
        selectedGroups: [],
        currentAction: null,
        actionResultName: null,
    };
    componentDidMount() {
        this.fetchGroups();
    }
    fetchGroups = () => {
        const { companyId } = this.props;
        this.setState({
            groups: [],
            groupsLoading: true,
        });
        loadGroups(companyId)
            .then(groups => {
                this.setState({
                    groups,
                    groupsLoading: false,
                });
            })
            .catch(() => {
                this.setState({
                    groupsLoading: false,
                });
            });
    };
    getAvailableActions = (selectedGroups, actions) => {
        return actions;
    };

    getActions = () => {
        return [
            {
                key: DELETE_GROUPS,
                name: 'Delete groups',
                action: this.handleAction(DELETE_GROUPS),
            },
        ];
    };

    getColumns = editable => {
        const { companyId } = this.props;
        return [
            {
                field: 'uuid:',
                title: 'Uuid',
                hidden: true,
                notFilter: true,
                export: false,
            },
            {
                field: 'name',
                title: 'Name',
                cellStyle: {
                    minWidth: '30%',
                },
            },
            {
                field: 'description',
                title: 'Description',
                cellStyle: {
                    minWidth: '80%',
                },
            },
            {
                field: 'action',
                title: '',
                notFilter: true,
                export: false,
                cellStyle: {
                    width: '125px',
                },
                render: row => {
                    const { uuid } = row;
                    return row.default || !editable ? (
                        <DetailsButton
                            component={Link}
                            to={`/companies/${companyId}/partner/company_groups/view/${uuid}`}
                        />
                    ) : (
                        <EditButton
                            component={Link}
                            to={`/companies/${companyId}/partner/company_groups/edit/${uuid}`}
                        />
                    );
                },
            },
        ];
    };

    handleAction = currentAction => selectedGroups => {
        this.setState({
            currentAction,
            selectedGroups,
        });
    };

    handleCloseDialog = () => () => {
        this.setState({ currentAction: null });
    };

    handleOkDialog = ({ callback, actionResultName }) => () => {
        this.setState({ currentAction: null, actionResultName }, () =>
            callback(this.state.selectedGroups, Boolean(actionResultName))
        );
    };

    getAddGroupsActions = () => (
        <MenuList>
            <MenuItem
                component={Link}
                to={`/companies/${this.props.companyId}/partner/company_groups/create`}
            >
                Add company group
            </MenuItem>
        </MenuList>
    );

    handleRemove = groups => {
        const { companyId } = this.props;
        removeGroups(groups, companyId).then(() => this.fetchGroups());
    };

    renderDialog = () => {
        const { currentAction } = this.state;
        const dialog = {
            [DELETE_GROUPS]: {
                title: 'Delete groups',
                warning: 'Are you sure you want to delete groups:',
            },
        };

        const callbacks = {
            [DELETE_GROUPS]: { callback: this.handleRemove },
        };

        if (dialog[currentAction]) {
            return (
                <ConfirmationDialog
                    open={true}
                    {...dialog[currentAction]}
                    data={this.state.selectedGroups.map(item => item.name)}
                    onCancel={this.handleCloseDialog(currentAction)}
                    onOk={this.handleOkDialog(callbacks[currentAction])}
                />
            );
        }
    };

    getActionMenuItem = selectedGroups => {
        const actions = this.getActions(this.props);
        const availableActions = this.getAvailableActions(
            selectedGroups,
            actions
        );

        const menuItems =
            availableActions.length > 0
                ? availableActions.map(action => ({
                      key: action.key,
                      name: action.name,
                      onClick: dropdownCloseCallback => {
                          action.action(selectedGroups);
                          dropdownCloseCallback();
                      },
                  }))
                : [
                      {
                          key: 'no',
                          name: 'No common action',
                          onClick: dropdownCloseCallback => {
                              dropdownCloseCallback();
                          },
                      },
                  ];

        return menuItems;
    };

    handleSelectionChange = val => {
        this.setState({ selectedGroups: val });
    };

    render() {
        const { groups, groupsLoading, selectedGroups } = this.state;
        const { app } = this.props;
        const editable = app.canChange(Access.COMPANIES_PARTNER_COMPANY_GROUPS);
        const columns = this.getColumns(editable);

        const selectedActions = this.getActionMenuItem(selectedGroups);

        return (
            <>
                {this.state.currentAction && this.renderDialog()}
                <WhiteBack />
                <MTable
                    stateKey="CompanyGroups"
                    columns={columns}
                    data={groups}
                    loading={groupsLoading}
                    title={null}
                    actionMenuItems={selectedActions}
                    onSelectionChange={this.handleSelectionChange}
                    addMenuItems={this.getAddGroupsActions}
                    canChange={editable}
                    options={{
                        selection: editable,
                        selectionProps: row => ({
                            disabled: !(editable && !row.default),
                        }),
                    }}
                />
            </>
        );
    }
}

export default flowRight(withStyles(styles), withAppContext)(Groups);
